<template>
  <div>
    <div>
      <el-form :inline="true" ref="form2" @submit.native.prevent>
        <el-form-item>
          <el-input v-model="param.name" maxlength="200" style="width: 200px" @keyup.native.enter="list"></el-input>
          <el-button type="primary" @click="list">查询</el-button>
          <el-button type="primary" @click="random">随机</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div align="center">
      <el-table :data="tableData" ref="dataTable" style="width: 100%">
        <el-table-column type="index" label="序号" width="50"/>
        <el-table-column prop="name" label="引子" width="400" show-overflow-tooltip/>
        <el-table-column prop="answer" label="歇后语" width="300" show-overflow-tooltip/>
      </el-table>
    </div>
  </div>
</template>

<script>
import * as http from '../api/http'
import global from '../components/Global'

export default {
  name: 'Xiehouyu',
  data () {
    return {
      tableData: [],
      param: {name: null}
    }
  },
  created () {
    // this.list()
  },
  methods: {
    list () {
      if (this.param.name === undefined || this.param.name === null) {
        this.$message.error('请输入查询条件。')
        return
      }
      this.tableData = []
      http.post(global.url0 + 'nsy-xiehouyu/list/', this.param).then(
        res => {
          let resStr = res.data.toString
          if (resStr.length > 0 && !String.startsWith(resStr, '[')) {
            this.$message.error(res)
            return
          }
          // console.log(res)
          this.tableData = res.data
        }
      )
    },
    random () {
      this.tableData = []
      http.post(global.url0 + 'nsy-xiehouyu/random/', null).then(
        res => {
          let resStr = res.data.toString
          if (resStr.length > 0 && !String.startsWith(resStr, '[')) {
            this.$message.error(res)
            return
          }
          // console.log(res)
          this.tableData = res.data
        }
      )
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/views/Xiehouyu.vue